export const stringOrNumberHelper = (value: string | number, unit?: string) =>
	typeof value === 'string' ? value : `${value}${unit || 'rem'}`;
